import { toast } from 'react-toastify'

export default (str, remoteConfig) => {
  if (!remoteConfig || remoteConfig.appEnv !== 'dev') {
    return
  }

  toast(str)
}
